import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { CircleInfoFarFAIcon as s } from "../../components/Icons/index.js";
import '../../assets/index28.css';const c = "ErrorMessage-module__error___0htVr", n = {
  error: c
}, a = ({ error: e }) => /* @__PURE__ */ o("div", { className: n.error, children: [
  /* @__PURE__ */ r(s, { size: 12 }),
  /* @__PURE__ */ r("p", { children: e })
] });
export {
  a as ErrorMessage
};
